import { of, from } from 'rxjs'
import { switchMap, share, delay, catchError, tap } from 'rxjs/operators'
import { RESPONSE_BADRESPONSE, RESPONSE_OFFLINE, RESPONSE_NOTFOUND, RESPONSE_UNAUTHORIZED, RESPONSE_FORBIDDEN } from '../constants/responses'
import debug from '../core/debug'
import 'whatwg-fetch'
import { includes } from '../libraries/lodash'
import Cookies from 'js-cookie'
import { PREVENT_MULTIPLE_LOGIN } from '../constants/feature-flags'

// TODO - define this per project, or just have it overridable?
const checkStatus = function (url, forbiddenAllowed, response) {
  const loggedOutResponses = forbiddenAllowed ? [307] : [307, 403]
  if (response.type === 'opaque' || includes(loggedOutResponses, response.status)) {
    const error = new Error('Not logged in.')
    Object.assign(error, { status: 404 })
    if (process.env.NODE_ENV === 'production') {
      location.href = '/disconnectFC'
    }
    debug.log('%cCookies are out of date!', 'background: #F55641; color: #FFF; font: 20px/50px arial; padding: 10px 20px;')
    debug.log('%c     ', 'font-size: 100px; background: url(https://media.giphy.com/media/sIIhZliB2McAo/giphy.gif)')
    throw error
  } else if (response.ok) {
    return response
  } else {
    let error = new Error(response.statusText)
    Object.assign(error, { status: response.status })
    throw error
  }
}

const translateStatus = function (status) {
  switch (+status) {
    case 408: // Request Timeout
      return RESPONSE_OFFLINE
    case 404:
      return RESPONSE_NOTFOUND
    case 401:
      return RESPONSE_UNAUTHORIZED
    case 403:
      return RESPONSE_FORBIDDEN
    default:
      return RESPONSE_BADRESPONSE
  }
}

const request = function (params, forbiddenAllowed) {
  const { headers = {}, url, method = 'get', mode: _mode } = params
  const mode = _mode
    ? { mode: _mode }
    : method === 'get' && Object.keys(headers).length === 0
      ? { mode: 'no-cors' }
      : {} // no-cors overrides headers!
  const request = new Request(
    url,
    { ...params, ...mode, headers: new Headers(headers), credentials: 'same-origin' }
  )
  return from(
    fetch(request)
      .then(checkStatus.bind(null, url, forbiddenAllowed))
      .then(resp => resp.text())
  ).pipe(
    delay(10),
    catchError(
      (e) => {
        debug.warn(`Request error from ${url}. ${e.message}`)
        return of(translateStatus(+e.status))
      }
    ),
    tap(() => {
      if (PREVENT_MULTIPLE_LOGIN && !forbiddenAllowed && !Cookies.get().hasOwnProperty('fc-rememberMe')) {
        location.href = '/disconnectFC'
      }
    })
  )
}

export const observeRequest = ({ forbiddenAllowed }) => function (settings, trigger = of(true)) {
  return trigger.pipe(switchMap(() => request(settings, forbiddenAllowed)),share())
}
